import * as React from 'react'
import { ShownCountryWithLocations } from './types'
import './locationListTable.scss'

interface LocationListTableProps {
	shownCountriesWithLocations: ShownCountryWithLocations[]
	selectedCountry: string
}

const LocationListTable = ({ shownCountriesWithLocations, selectedCountry }: LocationListTableProps) => {
	return (
		<table className="location-list-table">
			<tbody>
				{shownCountriesWithLocations
					.filter((countryWithLocations) => countryWithLocations.countryCode === selectedCountry)
					.map((countryWithLocations) => [
						<React.Fragment key={`country_${countryWithLocations.countryCode}`}>
							<tr>
								<td className="location-list-table__cell" colSpan={2}>
									<div className="location-list-table__country">
										{countryWithLocations.countryName}
										<span className="location-list-table__location-count">
											{countryWithLocations.locations.length} site
											{countryWithLocations.locations.length === 1 ? '' : 's'}
										</span>
									</div>
								</td>
							</tr>
							<tr className="location-list-table__spacer">
								<td className="location-list-table__cell" colSpan={2}></td>
							</tr>
							{countryWithLocations.locations.map((location) => (
								<tr key={`location_${location.title}`}>
									<td className="location-list-table__cell location-list-table__location-title">
										{location.title}
									</td>
									<td className="location-list-table__cell">
										<a
											className="location-list-table__link"
											href={`https://${location.url}`}
											target="_blank"
											rel="noreferrer"
										>
											{location.url}
										</a>
									</td>
								</tr>
							))}
						</React.Fragment>,
					])}
			</tbody>
		</table>
	)
}

export default LocationListTable
